import {createAsyncThunk} from '@reduxjs/toolkit';
import {get} from '../utils/requests';
import {SWFT_DIGITAL_API_HOST} from '../constants';
import {USER_PROFILE_ENDPOINT} from '../constants/endpoints';
import Tracker from 'src/lib/analytics/tracker';
import {ErrorTags, EventNames} from 'src/lib/analytics/events';
import {UserProfile} from 'src/api/types/response';
import Cookies from 'js-cookie';
import {EVENT_NAMES, TrackGoogleEvent} from '../lib/analytics/gtag';

const getUserProfile = createAsyncThunk('users/getUserProfile', async (props: {profile?: UserProfile}, thunkApi) => {
    try {
        if (props.profile) return props.profile;

        const data: UserProfile = await get(SWFT_DIGITAL_API_HOST + USER_PROFILE_ENDPOINT);
        Cookies.set('user_id', data.username);
        Cookies.set('name', data.first_name);
        Cookies.set('email', data.email);
        Tracker.init();
        Tracker.setUserInfo(data);
        Tracker.trackEvent(EventNames.APP_OPEN);
        TrackGoogleEvent({action: EVENT_NAMES.APP_OPEN, label: 'Dashboard'});
        return data;
    } catch (e: any) {
        Tracker.trackError(e, ErrorTags.GET_USER_PROFILE_ERROR);
        throw e;
    }
});

const refreshUserProfile = createAsyncThunk('users/refreshUserProfile', async (_, thunkApi) => {
    try {
        const data: UserProfile = await get(SWFT_DIGITAL_API_HOST + USER_PROFILE_ENDPOINT);
        thunkApi.dispatch(
            getUserProfile({
                profile: data,
            }),
        );
        return data;
    } catch (e: any) {
        Tracker.trackError(e, ErrorTags.GET_USER_PROFILE_ERROR);
        throw e;
    }
});

export {getUserProfile, refreshUserProfile};
